import * as React from 'react';
import { observer } from 'mobx-react';
import { Routes, useJourneyNavigation } from '../../../routes';
import { OrgPageWidget } from '../../../widgets/page/OrgPageWidget';
import { PageHeadingWidget } from '../../../widgets/page/PageHeadingWidget';
import { FormikInputWidget } from '../../../widgets/inputs/FormikInput';
import { styled } from '../../../theme';
import { Routes as RoutesSwitch } from 'react-router-dom';
import { Route } from 'react-router-dom';
import { LayerWidget } from '../../../layers/LayerWidget';
import { BillingDetailsDialog } from './BillingDetailsDialog';
import { ButtonType, ButtonWidget } from '../../../widgets/buttons/ButtonWidget';
import { CardDetailsDialog } from './CardDetailsDialog';

export const BillingPage: React.FC = observer(() => {
  const { relativeRoute, navigate, params } = useJourneyNavigation(Routes.BILLING);

  return (
    <OrgPageWidget activeItemKey={Routes.BILLING}>
      <S.Container>
        <PageHeadingWidget title={'Billing Settings'} />
        <S.Section>
          <S.P>Modify the billing details which appear on invoices and receipts.</S.P>
          <S.Button
            label="Update billing details"
            type={ButtonType.SECONDARY}
            action={async () => {
              navigate(Routes.BILLING_SETTINGS, {
                ...params
              });
            }}
          />
        </S.Section>
        <S.Section>
          <S.P>Modify the organization payment cards on file.</S.P>
          <S.Button
            label="Manage cards"
            type={ButtonType.SECONDARY}
            action={async () => {
              navigate(Routes.CARD_SETTINGS, {
                ...params
              });
            }}
          />
        </S.Section>
      </S.Container>
      <RoutesSwitch>
        <Route
          path={relativeRoute(Routes.BILLING_SETTINGS)}
          element={
            <LayerWidget<Routes.BILLING_SETTINGS>
              route={Routes.BILLING_SETTINGS}
              options={{ withBackdrop: true, userCanExit: false }}
              renderLayer={({ handler }) => {
                return <BillingDetailsDialog handler={handler} />;
              }}
            />
          }
        />
        <Route
          path={relativeRoute(Routes.CARD_SETTINGS)}
          element={
            <LayerWidget<Routes.CARD_SETTINGS>
              route={Routes.CARD_SETTINGS}
              options={{ withBackdrop: true, userCanExit: false }}
              renderLayer={({ handler }) => {
                return <CardDetailsDialog handler={handler} />;
              }}
            />
          }
        />
      </RoutesSwitch>
    </OrgPageWidget>
  );
});

namespace S {
  export const Container = styled.div`
    margin: auto;
    margin-bottom: 20px;
    width: 600px;
  `;

  export const Input = styled(FormikInputWidget)`
    margin-bottom: 15px;

    &:last-of-type {
      margin-bottom: 0;
    }
  `;

  export const Section = styled.div`
    padding-top: 40px;
  `;

  export const P = styled.div`
    font-size: 14px;
    max-width: 600px;
    padding-bottom: 20px;
    color: ${(p) => p.theme.text.secondary};
  `;

  export const Button = styled(ButtonWidget)`
    width: 300px;
  `;
}
